import { useEffect, useState, useCallback } from "react";
import api from "../api";
import DateIT from "./DateIT";
import { TaskMoveButton } from "./TaskMove";

const fmtDT = (s) => (s ? new Date(s).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

// Sezione "Appunti e Incarichi" per la scheda azienda.
export default function CompanyNotesTasks({ companyId }) {
  const [notes, setNotes] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [taskForm, setTaskForm] = useState(null); // {title, due}

  const load = useCallback(() => {
    api.get(`/companies/${companyId}/notes`).then((r) => setNotes(r.data)).catch(() => {});
    api.get(`/tasks?company_id=${companyId}`).then((r) => setTasks(r.data)).catch(() => {});
  }, [companyId]);
  useEffect(() => { load(); }, [load]);

  const addNote = async () => {
    if (!newNote.trim()) return;
    await api.post(`/companies/${companyId}/notes`, { text: newNote.trim() });
    setNewNote(""); load();
  };
  const delNote = async (nid) => { await api.delete(`/companies/notes/${nid}`); load(); };
  const noteToTask = (n) => setTaskForm({ title: n.text.slice(0, 140), due: "" });
  const saveTask = async () => {
    if (!taskForm.title.trim()) return;
    await api.post("/tasks", { title: taskForm.title.trim(), due_date: taskForm.due || null, company_id: companyId });
    setTaskForm(null); load();
  };
  const toggleTask = async (t) => { await api.put(`/tasks/${t.id}`, { status: t.status === "fatto" ? "da_fare" : "fatto" }); load(); };
  const delTask = async (t) => { if (window.confirm("Eliminare l'incarico?")) { await api.delete(`/tasks/${t.id}`); load(); } };

  return (
    <div className="panel" data-testid="company-notes-panel">
      <h3 style={{ marginTop: 0 }}>📝 Appunti e Incarichi</h3>
      <p className="muted" style={{ marginTop: -6 }}>Annota cosa vi siete detti, idee e riflessioni. Da ogni appunto puoi creare un incarico.</p>
      <textarea rows={3} value={newNote} onChange={(e) => setNewNote(e.target.value)} data-testid="company-note-input"
        placeholder="Es. Valutare passaggio a regime ordinario, controllare crediti IVA…" style={{ width: "100%" }} />
      <div style={{ marginTop: 6 }}><button className="btn sm primary" onClick={addNote} disabled={!newNote.trim()} data-testid="company-note-add">+ Aggiungi appunto</button></div>

      <div style={{ marginTop: 12 }}>
        {notes.length === 0 && <span className="muted">Nessun appunto ancora.</span>}
        {notes.map((n) => (
          <div key={n.id} style={{ borderLeft: "3px solid var(--border)", padding: "6px 10px", marginBottom: 8 }} data-testid={`company-note-${n.id}`}>
            <div className="muted" style={{ fontSize: 11 }}>{fmtDT(n.created_at)}</div>
            <div style={{ whiteSpace: "pre-wrap" }}>{n.text}</div>
            <div style={{ marginTop: 4, display: "flex", gap: 6 }}>
              <button className="btn sm" onClick={() => noteToTask(n)} data-testid={`note-to-task-${n.id}`}>→ Crea incarico</button>
              <button className="btn sm danger" onClick={() => delNote(n.id)}>Elimina</button>
            </div>
          </div>
        ))}
      </div>

      <h4 style={{ marginBottom: 6 }}>Incarichi</h4>
      <table>
        <thead><tr><th></th><th>Incarico</th><th>Scadenza</th><th></th></tr></thead>
        <tbody>
          {tasks.map((t) => (
            <tr key={t.id} data-testid={`company-task-${t.id}`} style={{ opacity: t.status === "fatto" ? 0.5 : 1 }}>
              <td><input type="checkbox" checked={t.status === "fatto"} onChange={() => toggleTask(t)} data-testid={`company-task-done-${t.id}`} /></td>
              <td><span style={{ textDecoration: t.status === "fatto" ? "line-through" : "none" }}>{t.title}</span>{t.description && <div className="muted" style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>{t.description}</div>}</td>
              <td className="muted">{t.due_date ? new Date(t.due_date).toLocaleDateString("it-IT") : "—"}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                <TaskMoveButton task={t} onMoved={load} />{" "}
                <button className="btn sm danger" onClick={() => delTask(t)}>Elimina</button>
              </td>
            </tr>
          ))}
          {tasks.length === 0 && <tr><td colSpan={4} className="muted">Nessun incarico.</td></tr>}
        </tbody>
      </table>

      {taskForm && (
        <div className="panel" style={{ marginTop: 10, background: "rgba(59,130,246,.08)" }}>
          <div className="field"><label>Descrizione incarico *</label><input value={taskForm.title} onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })} data-testid="company-task-title" /></div>
          <div className="field"><label>Scadenza</label><DateIT value={taskForm.due} onChange={(v) => setTaskForm({ ...taskForm, due: v })} /></div>
          <div className="modal-actions">
            <button className="btn" onClick={() => setTaskForm(null)}>Annulla</button>
            <button className="btn primary" onClick={saveTask} data-testid="company-task-save">Crea incarico</button>
          </div>
        </div>
      )}
    </div>
  );
}
